import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type { TimeRangeKey, TimelineEvent } from "@colab/shared";

export function useActivityTimeline(range: TimeRangeKey) {
  return useQuery<TimelineEvent[], ApiClientError>({
    queryKey: queryKeys.portal.analytics.activity(range),
    queryFn: () =>
      apiFetch<TimelineEvent[]>(`/portal/analytics/activity?range=${range}`),
  });
}
